//#region src/dom/feature.ts
function definePlayerFeature(definition) {
	const preserved = Object.values(definition.config ?? {}).map((entry) => entry.state);
	return {
		...definition,
		...preserved.length > 0 ? { preserve: preserved } : {}
	};
}
/** Merge the configuration declarations from the selected player features. */
function combinePlayerFeatureConfigs(features) {
	const definitions = features.map((feature) => feature.config ?? {});
	{
		const seen = /* @__PURE__ */ new Set();
		for (const definition of definitions) for (const key of Object.keys(definition)) {
			if (seen.has(key)) console.warn(`[vjs-core] duplicate config key "${key}" — later feature overwrites earlier one`);
			seen.add(key);
		}
	}
	return Object.assign({}, ...definitions);
}
/** Forward one configuration input through its feature-owned private action. */
function setPlayerConfigValue(store, entry, value) {
	const action = store[entry.action];
	if (typeof action !== "function") throw new TypeError(`Missing config action "${String(entry.action)}"`);
	action(value);
}
//#endregion
export { combinePlayerFeatureConfigs, definePlayerFeature, setPlayerConfigValue };

//# sourceMappingURL=feature.js.map